import { Box, Text } from '@rsos/base-components';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import CreateCustomMessage from './CreateCustomMessage';
import CustomMessagesTable from './CustomMessagesTable';
import PreconfiguredMessagesSearch from './PreconfiguredMessagesSearch';
import RsosMessagesTable from './RsosMessagesTable';

type Props = {
  messages: PreconfiguredResponse[];
  searchTerm: string;
  isLoading: boolean;
  isError: boolean;
  onSearch: (term: string) => void;
};

const PreconfiguredMessagesLegacy = ({
  messages,
  searchTerm,
  isLoading,
  isError,
  onSearch,
}: Props) => {
  return (
    <Box>
      <Text mt={24} size="xlarge" fontWeight="bold" color="primaryText">
        Preconfigured Messages
      </Text>
      <Text mt={2} size="normal" color="secondaryText">
        Create custom Preconfigured Messages for RapidSOS UNITE's Text-From-911
        service
      </Text>
      <Box my={3} horizontal flow={8} width="100%" align="center">
        <PreconfiguredMessagesSearch onSearch={onSearch} />
        <CreateCustomMessage />
      </Box>
      <RsosMessagesTable
        messages={messages.filter(message => message.owner === 'rapidsos')}
        searchTerm={searchTerm}
        isLoading={isLoading}
        isError={isError}
      />
      <CustomMessagesTable
        messages={messages.filter(message => message.owner !== 'rapidsos')}
        searchTerm={searchTerm}
        isLoading={isLoading}
        isError={isError}
      />
    </Box>
  );
};

export default PreconfiguredMessagesLegacy;
